import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addCategory, loadingSet } from "../store/actions/categoryActions";
import Swal from "sweetalert2";
import LoadingComponent from "../components/LoadingComponent";

export default function AddCategoryPage() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { loading } = useSelector((state) => state.categories);
	const [newCategory, setNewCategory] = useState({
		name: "",
	});

	const changeInputNewCategory = (e) => {
		const { name, value } = e.target;
		setNewCategory({
			...newCategory,
			[name]: value,
		});
	};

	const submitHandler = (e) => {
		e.preventDefault();

		dispatch(addCategory(newCategory))
			.then(() => {
				Swal.fire({
					position: "top-end",
					icon: "success",
					title: "successfully added new category",
					showConfirmButton: false,
					timer: 1000,
				});
				navigate("/categories");
			})
			.catch((err) => {
				return Swal.fire({
					icon: "error",
					title: "Error",
					text: err,
				});
			})
			.finally(() => {
				dispatch(loadingSet(false));
			});
	};

	return (
		<>
			{loading ? (
				<LoadingComponent />
			) : (
				<div className="container">
					<h2 className="mb-3">Add Category</h2>
					<form onSubmit={submitHandler}>
						<div className="mb-3">
							<label className="form-label">Name</label>
							<input
								type="text"
								name="name"
								className="form-control"
								value={newCategory.name}
								onChange={changeInputNewCategory}
							/>
						</div>
						<div>
							<button type="submit" className="btn btn-primary">
								Save
							</button>
							<button onClick={() => navigate("/categories")} className="btn btn-danger ms-2">
								Cancel
							</button>
						</div>
					</form>
				</div>
			)}
		</>
	);
}
